import InformationCircle from "@/assets/icons/information-circle.svg";
import { cx } from "@/utils"; // existing helper for class-name concatenation

import styles from "./InfoBox.module.css";

type InfoBoxProps = {
  /** Extra class names, if the caller needs custom tweaks */
  className?: string;
  text: string;
};

const InfoBox = ({ className, text }: InfoBoxProps) => (
  <div className={cx(styles.container, className)}>
    <InformationCircle className={styles.icon} width="1rem" />
    <p className={styles.text}>{text}</p>
  </div>
);

export default InfoBox;
